import { Component, DoCheck, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { DailySeries } from 'app/models/course';
import { SeriesService } from 'app/lib/series.service';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import { AnalyticEvent } from 'app/lib/analytic-event';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-series-daily-content',
    templateUrl: './series-daily-content.component.html',
    styleUrls: ['./series-daily-content.component.scss'],
    standalone: false
})
export class SeriesDailyContentComponent implements OnInit, DoCheck {
    private dailyContentSubscription: Subscription | null = null;
    isDailyContentListLoaded: boolean = false;
    pastDailyContents: DailySeries[] = [];
    todaysDailyContent: DailySeries;
    isTodaysDailyContentLoaded: boolean = false;
    lang: string = 'en';
    constructor(
        private location: Location,
        private seriesService: SeriesService,
        private api: ApiService,
        private log: LogService,
        private translate: TranslateService
    ) {}

    ngOnInit(): void {
        this.lang = this.translate.currentLang;
        this.getTodaysDailyContent();
        this.getDailyContentList();
    }
    ngDoCheck() {
        this.lang = this.translate.currentLang;
    }
    goBack() {
        this.location.back();
    }
    getTodaysDailyContent() {
        this.isTodaysDailyContentLoaded = false;
        this.dailyContentSubscription =
            this.seriesService.dailySeriesContent.subscribe(data => {
                if (Object.keys(data).length) {
                    this.todaysDailyContent = new DailySeries(data);
                    this.isTodaysDailyContentLoaded = true;
                }
            });
        this.seriesService.getDailySeries();
    }

    getDailyContentList() {
        this.isDailyContentListLoaded = false;
        this.api.get('series/dailyseries/previous').subscribe(
            (result: any) => {
                this.log.event(
                    AnalyticEvent.internalPagesEvents.pastDailyContentLoaded
                );
                this.isDailyContentListLoaded = true;
                if (result?.length) {
                    this.pastDailyContents =
                        DailySeries.initializeArray(result);
                }
            },
            (error: any) => {
                this.log.error(
                    'Error getting daily content list. ' + error.message
                );
                this.log.event(
                    AnalyticEvent.internalPagesEvents.pastDailyContentFetchError
                );
            },
            () => {}
        );
    }

    goToRead(reads: any) {
          window.open(reads.fileUrl, '_blank');
          this.log.event(AnalyticEvent.internalPagesEvents.customOrgReadItemClicked, '',
            { title: reads["title" + this.lang] },
          );
          reads?.id && this.seriesService.logReadsSeriesClickCount(reads.id);
    }
}
